import React, { FunctionComponent } from 'react';
import { Typography } from '@mui/material';
import moment from 'moment';

import { ILessonHistoryLog } from '../../../../../../../../../../store/V2/LessonHistorySlice';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../../../../../../components/V2/Table/type1/TableStyles';
import { IUser } from '../../../../../../../../../../store/UserSlice';
import { getShortName } from '../../../../../../../../../../helper';

interface LessonHistoryLogTableRowProps {
  log: ILessonHistoryLog;
}

const LessonHistoryLogTableRow: FunctionComponent<LessonHistoryLogTableRowProps> = ({
  log,
}) => {
  const date = moment(log.createdAt);
  const createdBy = log.createdBy as IUser;
  const createdByName = getShortName(
    createdBy.firstname,
    createdBy.lastname,
    true
  );

  return (
    <StyledTableRow hover key={log._id}>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {date.format('DD MMM YYYY')}
        </Typography>
        <Typography fontSize="12px" color="#94A3B8">
          {date.format('hh:mm A')}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {createdByName}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography fontSize="14px" fontWeight={500} color="#1E293B">
          {log.title}
        </Typography>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default LessonHistoryLogTableRow;
